module.exports = __webpack_public_path__ + "img/3.705249d0.jpg";